import React, { useEffect, useState } from "react";
import { notification } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { fetchIpAddress } from "../../../../controllers/API";
import LoadingEffect from "../../../../components/Loading/LoadingEffect";
import {createInvoice}  from  "../../../../controllers/V1/invoice/invoiceControllers";
import {list as getLoadBalanceData} from "../../../../controllers/V1/walletStatement/walletStatementController";
import { updateDueAmount } from "../../../../controllers/V1/users/usersController";
import SelectUsers from "../../../../components/SelectUsers";
import moment from 'moment';
import {list as generalData} from "../../../../controllers/V1/cms/generalDataController";
import Big from 'big.js';

const bp = (n) => new Big(parseFloat(n) || 0);
const UserListEditPage = () => {
  
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState({
    start_time : '00:00:00',
    end_time : '00:01:00'
  });
  const [selectedUser, setSelectedUser] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('Loading, please wait...');

  // const [oldDueBalance, setOldDueBalance] = useState(0);
  const [addInDue, setAddInDue] = useState('N');

  const [invoiceData, setInvoiceData] = useState({});

  const getStatementDueAmount = (data = {}) =>
    parseFloat(bp(data?.subTotalDue).plus(bp(data?.other_charges)).toFixed(2));

  const applyUserDueAmount = async (user, dueAmount) => {
    if (!user || dueAmount === undefined || dueAmount === null || isNaN(parseFloat(dueAmount))) {
      return { status: false, message: 'Invalid due amount' };
  }
    let res = await updateDueAmount({
      pos_number: user?.pos_number || '',
      mobile_number: '',
      due_amount: dueAmount,
    });
    if (res.status !== true) {
      res = await updateDueAmount({
        pos_number: '',
        mobile_number: user?.users_mobile || '',
        due_amount: dueAmount,
      });
    }
    return res;
  };


  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const invoiceDataChange = (e) => {
    setInvoiceData((pre)=>({
      ...pre,
      [e.target.name] : e.target.value 
    }))
  } 
  
  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const currentUser = JSON.parse(ADDEDITDATA?.userData) || {}; 
      if(currentUser && currentUser?._id){
        setSelectedUser(JSON.parse(ADDEDITDATA?.userData));
      }
      if(!currentUser){
        alert('Please select user');
      } else if(!ADDEDITDATA.start_date || !ADDEDITDATA.start_time){
        alert('Please choose From date and time.');
      } else if(!ADDEDITDATA.end_date || !ADDEDITDATA.end_time){
        alert('Please choose To date and time.');
      } else{
        setIsLoading(true);
        setLoadingText('Fetching transaction history, Please wait...');
        
        const startDate = `${ADDEDITDATA?.start_date} ${ADDEDITDATA?.start_time}`;
        const endDate = `${ADDEDITDATA?.end_date} ${ADDEDITDATA?.end_time}`;
        const options = {
          condition : {
            $or : [
              {debit_user : currentUser?._id},
              {credit_user : currentUser?._id}
            ],
            createdAt : { $gte : startDate, $lte : endDate }
          }
        }
        const res = await getLoadBalanceData(options);
        setInvoiceData((pre)=>({
          ...pre,
          user_oid : currentUser?._id,
          user_id : currentUser?.users_id,
          store_name : currentUser?.store_name,
          user_name : `${currentUser?.users_name}`,
          mobile : currentUser?.users_mobile,
          email : currentUser?.users_email,
          pos_number : currentUser?.pos_number,
          due_amount : currentUser?.due_amount || 0,
        }));
        if(res?.status === true){
          setLoadingText('Calculating data, Please wait...');
          calculateInvoiceData(res?.result || [], currentUser?.due_amount ?? 0);
          setIsLoading(false);
        }else{
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  const getGeneralData = async () => {
    try {
      const option ={}
      const res = await generalData(option);
      if(res?.status === true){
        const time = moment().endOf('day').format('HH:mm:ss');
        const startTime = res?.result?.invoice_start_time;
        const endTime = res?.result?.invoice_end_time;
        setAddEditSata((pre)=>({
          ...pre,
          start_time : startTime || time,
          end_time : endTime || time
        }))
      }
    } catch (error) {
      
    }
  }

  useEffect(() => {
    getGeneralData();
    document.title = `B-Winn || ${ADDEDITDATA?._id ? "Edit" : "Add"} Invoice`;
  }, []);

/*********** Calculate Total Sales Amount ******* */
  const calculateInvoiceData = (data, dueBalance = 0) => {
    try {
      const parsedDueBalance = bp(dueBalance);

      if (!data?.length) {
        setInvoiceData((pre) => ({
          ...pre,
          lottoTotalSales:       '0.00',
          lottoTotalCommission:  '0.00',
          lottoPaidAmount:       '0.00',
          lottoIncentives:       0,
          voucherTotalSales:     '0.00',
          voucherTotalCommission:'0.00',
          voucherPaidAmount:     0,
          voucherIncentives:     0,
          e_commTotalSales:      '0.00',
          e_commTotalCommission: 0,
          e_commPaidAmount:      0,
          e_commIncentives:      0,
          totalSales:            '0.00',
          totalCommission:       '0.00',
          paidAmount:            '0.00',
          incentives:            0,
          totalDue:              0,
          old_balance:           parsedDueBalance.toFixed(2),
          other_charges:         pre?.other_charges ?? 0,
          subTotalDue:           parseFloat(parsedDueBalance.toFixed(2)),
        }));
        return;
      }

      // Accumulate transaction points using Big.js
      const result = data.reduce(
        (acc, item) => {
          const pts = bp(item.points);
          // Lotto ~ Daily Draw
          if (item.narration === 'Campaign Purchase') {
            acc.lottoSales = acc.lottoSales.plus(pts);
          } else if (item.narration === 'Campaign Commission') {
            acc.lottoCommission = acc.lottoCommission.plus(pts);
          } else if (item.narration === 'Campaign Purchase Cancel') {
            acc.lottoCancel = acc.lottoCancel.plus(pts);
          } else if (item.narration === 'Campaign Commission Reverse') {
            acc.lottoCommissionReverse = acc.lottoCommissionReverse.plus(pts);
          } else if (item.narration === 'Lotto Winner Redeem') {
            acc.lottoAmountPaid = acc.lottoAmountPaid.plus(pts);
          } else if (item.narration === 'Reverse Lotto Winner Redeem') {
            acc.lottoAmountPaid = acc.lottoAmountPaid.minus(pts);
          // Vouchers
          } else if (item.narration === 'Voucher Purchase') {
            acc.voucherSales = acc.voucherSales.plus(pts);
          } else if (item.narration === 'Voucher Commission') {
            acc.voucherCommission = acc.voucherCommission.plus(pts);
          } else if (item.narration === 'Voucher Order Cancel') {
            acc.voucherCancel = acc.voucherCancel.plus(pts);
          } else if (item.narration === 'Voucher Commission Reverse') {
            acc.voucherCommissionReverse = acc.voucherCommissionReverse.plus(pts);
          // Products / E-Comm
          } else if (item.narration === 'Product Order') {
            acc.e_commSales = acc.e_commSales.plus(pts);
          } else if (item.narration === 'Product Cancel') {
            acc.e_commCancel = acc.e_commCancel.plus(pts);
          }
          return acc;
        },
        {
          lottoSales:             new Big(0),
          lottoCommission:        new Big(0),
          lottoCancel:            new Big(0),
          lottoCommissionReverse: new Big(0),
          lottoAmountPaid:        new Big(0),
          voucherSales:           new Big(0),
          voucherCommission:      new Big(0),
          voucherCancel:          new Big(0),
          voucherCommissionReverse: new Big(0),
          e_commSales:            new Big(0),
          e_commCancel:           new Big(0),
        }
      );

      // Derived totals — all Big.js
      const totalLottoSales       = result.lottoSales.minus(result.lottoCancel);
      const totalLottoCommission  = result.lottoCommission.minus(result.lottoCommissionReverse);
      const totalVoucherSales     = result.voucherSales.minus(result.voucherCancel);
      const totalVoucherCommission = result.voucherCommission.minus(result.voucherCommissionReverse);
      const totalE_commSales      = result.e_commSales.minus(result.e_commCancel);

      const totalSalesAmount      = totalLottoSales.plus(totalVoucherSales).plus(totalE_commSales);
      const totalCommissionAmount = totalLottoCommission.plus(totalVoucherCommission);
      const totalPaidAmount       = result.lottoAmountPaid;

      const totalDue              = totalSalesAmount.minus(totalCommissionAmount).minus(totalPaidAmount);
      const subTotalDue           = totalDue.plus(parsedDueBalance);

      setInvoiceData((pre) => ({
        ...pre,
        lottoTotalSales:        totalLottoSales.toFixed(2),
        lottoTotalCommission:   totalLottoCommission.toFixed(2),
        lottoPaidAmount:        totalPaidAmount.toFixed(2),
        lottoIncentives:        0,

        voucherTotalSales:      totalVoucherSales.toFixed(2),
        voucherTotalCommission: totalVoucherCommission.toFixed(2),
        voucherPaidAmount:      0,
        voucherIncentives:      0,

        e_commTotalSales:       totalE_commSales.toFixed(2),
        e_commTotalCommission:  0,
        e_commPaidAmount:       0,
        e_commIncentives:       0,

        totalSales:             totalSalesAmount.toFixed(2),
        totalCommission:        totalCommissionAmount.toFixed(2),
        paidAmount:             totalPaidAmount.toFixed(2),
        incentives:             0,

        totalDue:               parseFloat(totalDue.toFixed(2)),
        old_balance:            parsedDueBalance.toFixed(2),
        other_charges:          0,
        subTotalDue:            parseFloat(subTotalDue.toFixed(2)),
      }));

    } catch (error) {
      console.log('error', error);
    }
  };
const handlePreview = (data = {})=>{
  try {
      const params = {
        invoice_no          : invoiceData?.invoice_no || data.invoice_no || '0000',
        invoice_date        : invoiceData?.invoice_date || moment().format('YYYY-MM-DD'),
        
        users_id            : selectedUser?.users_id,
        users_oid           : selectedUser?._id,
        store               : selectedUser?.store_name,
        users_name          : `${selectedUser?.users_name} ${selectedUser?.last_name}`,
        users_mobile        : selectedUser?.users_mobile,
        bind_person_name   : selectedUser?.bind_person_name,
        bind_person_mobile   : selectedUser?.bind_person_mobile,
        area                : selectedUser?.area,
        pos_serial_id       : selectedUser?.pos_serial_id,
        pos_number          : selectedUser?.pos_number,
        payment_mode        : invoiceData?.payment_mode || 'Cash',
  
        start_date          : `${ADDEDITDATA?.start_date} ${ADDEDITDATA?.start_time}`,
        start_time          : `${ADDEDITDATA?.start_time}`,
        end_date            : `${ADDEDITDATA?.end_date} ${ADDEDITDATA?.end_time}`,
        end_time            : `${ADDEDITDATA?.end_time}`,
        due_date            : invoiceData?.due_date || '',

        lottoTotalSales     : invoiceData?.lottoTotalSales || 0,
        lottoTotalCommission : invoiceData?.lottoTotalCommission || 0,
        lottoPaidAmount     : invoiceData?.lottoPaidAmount || 0,
        lottoIncentives     : invoiceData?.lottoIncentives || 0,
        
        voucherTotalSales    : invoiceData?.voucherTotalSales || 0,
        voucherTotalCommission : invoiceData?.voucherTotalCommission || 0,
        voucherPaidAmount    : invoiceData?.voucherPaidAmount || 0,
        voucherIncentives     : invoiceData?.voucherIncentives || 0,

        e_commTotalSales    : invoiceData?.e_commTotalSales || 0,
        e_commTotalCommission : invoiceData?.e_commTotalCommission || 0,
        e_commPaidAmount    : invoiceData?.e_commPaidAmount || 0,
        e_commIncentives     : invoiceData?.e_commIncentives || 0,
  
        total_sales         : invoiceData?.totalSales,
        total_commission    : invoiceData?.totalCommission,
        total_paid          : invoiceData?.paidAmount || 0,
        total_incentives    : invoiceData?.incentives || 0,
        total_due           : invoiceData?.totalDue || 0,
  
        old_pending_balance : invoiceData?.old_balance || 0,
        other_charges       : invoiceData?.other_charges || 0,
        sub_total_due       : invoiceData?.subTotalDue || 0,
      }
      
      const {
        store,users_name, pos_number, users_mobile, invoice_date, invoice_no, payment_mode, start_date, start_time, end_date, end_time, bind_person_name, bind_person_mobile, area,

        lottoTotalSales, lottoTotalCommission, lottoPaidAmount, lottoIncentives,
        e_commTotalSales, e_commTotalCommission, e_commPaidAmount, e_commIncentives,
        voucherTotalSales, voucherTotalCommission, voucherPaidAmount, voucherIncentives,
        sub_total_due, total_incentives, 
        total_sales, total_commission, total_paid, total_due, 
        other_charges, old_pending_balance, 
       } = params;
     
      let previewURL = `/invoice/preview?`
      previewURL    +=  `autoDownload=N`
      previewURL    +=  `&store_name=${store}`
      previewURL    +=  `&user_name=${users_name}`
      previewURL    +=  `&pos_number=${pos_number}`
      previewURL    +=  `&mobile=${users_mobile}`
      previewURL    +=  `&totalSales=${total_sales}`
      previewURL    +=  `&totalCommission=${total_commission}`
      previewURL    +=  `&paidAmount=${total_paid}`
      previewURL    +=  `&totalDue=${total_due}`
      previewURL    +=  `&other_charges=${other_charges}`
      previewURL    +=  `&old_balance=${old_pending_balance}`
      previewURL    +=  `&subTotalDue=${sub_total_due}`
      previewURL    +=  `&incentives=${total_incentives}`
      previewURL    +=  `&invoice_date=${invoice_date}`
      previewURL    +=  `&invoice_no=${invoice_no}`
      previewURL    +=  `&payment_mode=${payment_mode}`
      previewURL    +=  `&start_date=${start_date}`
      previewURL    +=  `&start_time=${start_time}`
      previewURL    +=  `&end_date=${end_date}`
      previewURL    +=  `&end_time=${end_time}`
      previewURL    +=  `&bind_person_name=${bind_person_name}`
      previewURL    +=  `&bind_person_mobile=${bind_person_mobile}`
      previewURL    +=  `&area=${area}`

      previewURL    +=  `&lottoTotalSales=${lottoTotalSales}`
      previewURL    +=  `&lottoTotalCommission=${lottoTotalCommission}`
      previewURL    +=  `&lottoPaidAmount=${lottoPaidAmount}`
      previewURL    +=  `&lottoIncentives=${lottoIncentives}`

      previewURL    +=  `&e_commTotalSales=${e_commTotalSales}`
      previewURL    +=  `&e_commTotalCommission=${e_commTotalCommission}`
      previewURL    +=  `&e_commPaidAmount=${e_commPaidAmount}`
      previewURL    +=  `&e_commIncentives=${e_commIncentives}`

      previewURL    +=  `&voucherTotalSales=${voucherTotalSales}`
      previewURL    +=  `&voucherTotalCommission=${voucherTotalCommission}`
      previewURL    +=  `&voucherPaidAmount=${voucherPaidAmount}`
      previewURL    +=  `&voucherIncentives=${voucherIncentives}`

      
      window.open(previewURL, '_blank');
  } catch (error) {
    alert('Invoice data not fount');
  }
}

const handleGenerate = async () => {
  try {
    setLoadingText('Please wait your request is in process.')
    setIsLoading(true);
    const ipAddress  = await fetchIpAddress();
    const params = {
      invoice_no          : invoiceData?.invoice_no,
      invoice_date        : invoiceData?.invoice_date,
      
      users_id            : selectedUser?.users_id,
      users_oid           : selectedUser?._id,
      store               : selectedUser?.store_name,
      users_name          : `${selectedUser?.users_name} ${selectedUser?.last_name}`,
      users_mobile        : selectedUser?.users_mobile,
      area                : selectedUser?.area || 'N/A',
      bind_person_name    : selectedUser?.bind_person_name || 'N/A',      
      bind_person_mobile  : selectedUser?.bind_person_mobile || null,      
      pos_serial_id       : selectedUser?.pos_serial_id || 'N/A',
      pos_number          : selectedUser?.pos_number,
      payment_mode        : invoiceData?.payment_mode,

      start_date          : `${ADDEDITDATA?.start_date}`,
      start_time          : `${ADDEDITDATA?.start_time}`,
      end_date            : `${ADDEDITDATA?.end_date}`,
      end_time            : `${ADDEDITDATA?.end_time}`,
      due_date            : invoiceData?.due_date || '',

      lottoTotalSales     : invoiceData?.lottoTotalSales || 0,
      lottoTotalCommission : invoiceData?.lottoTotalCommission || 0,
      lottoPaidAmount     : invoiceData?.lottoPaidAmount || 0,
      lottoIncentives     : invoiceData?.lottoIncentives || 0,
      
      voucherTotalSales    : invoiceData?.voucherTotalSales || 0,
      voucherTotalCommission : invoiceData?.voucherTotalCommission || 0,
      voucherPaidAmount    : invoiceData?.voucherPaidAmount || 0,
      voucherIncentives     : invoiceData?.voucherIncentives || 0,

      e_commTotalSales    : invoiceData?.e_commTotalSales || 0,
      e_commTotalCommission : invoiceData?.e_commTotalCommission || 0,
      e_commPaidAmount    : invoiceData?.e_commPaidAmount || 0,
      e_commIncentives     : invoiceData?.e_commIncentives || 0,

      total_sales         : invoiceData?.totalSales,
      total_commission    : invoiceData?.totalCommission,
      total_paid          : invoiceData?.paidAmount || 0,
      total_incentives    : invoiceData?.incentives,
      total_due           : invoiceData?.totalDue,

      old_pending_balance : invoiceData?.old_balance,
      other_charges       : invoiceData?.other_charges,
      sub_total_due       : invoiceData?.subTotalDue,
      add_in_due          : addInDue,

      created_ip          : ipAddress
    }
    const res = await createInvoice(params);
    if(res.status === true){
      if (addInDue === 'Y') {
        const dueUpdateRes = await applyUserDueAmount(
          selectedUser,
          getStatementDueAmount(invoiceData)
        );
        if (dueUpdateRes.status !== true) {
          notification.open({
            message: "Oops!.",
            description: `Invoice generated but due amount update failed: ${dueUpdateRes?.message || 'System error'}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 3,
          });
        }
      }
      notification.open({
        message: "Success.",
        description: `Invoice generated Successfully.`,
        placement: "topRight",
        icon: <CheckCircleOutlined style={{ color: "green" }} />,
        duration: 2,
      });
      handlePreview(res.result);
      navigate('/invoice/list');
    } else{
      notification.open({
        message: "Oops!.",
        description: `${res.message}`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
    setIsLoading(false);
  } catch (error) {
    setIsLoading(false);
  }
}
  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> Generate Invoice </h5>
          </React.Fragment>
          <Link to="/invoice/list">
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <ArrowLeftOutlined /> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}>
                <div className="row ">
                  <div className="row">
                    {/* Search By */}
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="admin_first_name" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Customer/Retailer's store :{" "}
                      </label>
                      <SelectUsers
                        user_type='' 
                        setAddEditData={setAddEditSata} 
                        defaultSelect={ADDEDITDATA?._id ? {
                          label: `${ADDEDITDATA.user_id?.users_name} ${ADDEDITDATA.user_id?.last_name} | ${ADDEDITDATA.user_id?.users_mobile}`,
                          value: JSON.stringify({
                              _id: ADDEDITDATA.user_id?._id,
                              users_name: ADDEDITDATA.user_id?.users_name,
                              last_name: ADDEDITDATA.user_id?.last_name,
                              users_mobile: ADDEDITDATA.user_id?.users_mobile
                          })
                        } : {}} 
                      />
                    </div>

                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="start_date"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>From :{" "}
                      </label>
                      <input
                        type="date"
                        name="start_date"
                        className="form-control store_input_field"
                        id="start_date"
                        onChange={handleChange}
                      />
                      {error.start_date ? (
                        <p style={{ color: "red" }}>{error.start_date}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="start_time"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="time"
                        name="start_time"
                        className="form-control store_input_field"
                        id="start_time"
                        value={ADDEDITDATA?.start_time}
                        onChange={handleChange}
                      />
                      {error.start_time ? (
                        <p style={{ color: "red" }}>{error.start_time}</p>
                      ) : (
                        ""
                      )}
                    </div>


                    <div className="form-group col-lg-3 col-md-3 col-sm-16 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="end_date"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>To :
                      </label> 
                      <input
                        type="date"
                        name="end_date"
                        className="form-control store_input_field"
                        id="end_date"
                        onChange={handleChange}
                      />   
                      {error.end_date ? (
                        <p style={{ color: "red" }}>{error.end_date}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="time"
                        name="end_time"
                        className="form-control store_input_field"
                        id="end_time"
                        value={ADDEDITDATA?.end_time}
                        onChange={handleChange}
                      />
                      {error.end_time ? (
                        <p style={{ color: "red" }}>{error.end_time}</p>
                      ) : (
                        ""
                      )}
                    </div>

                  </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button type="submit" className="btn btn-primary inventory_save_button" > Auto Calculate </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      {/* Generate Invoice Section */}
        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              {/* <form method="post" className="inventory_form_main_contnet"> */}
                <div className="row ">
                  <div className="row">
                    {/* Store Name */}
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="admin_first_name" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Customer/Retailer's store :{" "}
                      </label>
                      <input
                        title="Customer/Retailer's Store."
                        placeholder="Customer/Retailer's store"
                        type="text"
                        name="store_name"
                        className="form-control store_input_field"
                        id="store_name"
                        value={invoiceData?.store_name || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.store_name ? ( <p style={{ color: "red" }}>{error.store_name}</p> ) : ( "" )}
                    </div>
                    
                    {/* User's Name */}
                    <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="user_name" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Name :{" "}
                      </label>
                      <input
                        title="User's Name."
                        placeholder="Customer/Retailer's name"
                        type="text"
                        name="user_name"
                        className="form-control store_input_field"
                        id="user_name"
                        value={invoiceData?.user_name || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.user_name ? ( <p style={{ color: "red" }}>{error.user_name}</p> ) : ( "" )}
                    </div>
                    {/* User's Mobile */}
                    <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="mobile" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Mobile no. :{" "}
                      </label>
                      <input
                        title="Mobile No."
                        placeholder="Mobile No."
                        type="text"
                        name="mobile"
                        className="form-control store_input_field"
                        id="mobile"
                        value={invoiceData?.mobile}
                        onChange={invoiceDataChange}
                      />
                      {error.mobile ? ( <p style={{ color: "red" }}>{error.mobile}</p> ) : ( "" )}
                    </div>
                    {/* Start Date */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="start_date"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>From :{" "}
                      </label>
                      <input
                        type="date"
                        name="start_date"
                        className="form-control store_input_field"
                        id="start_date"
                        value={ADDEDITDATA?.start_date}
                        onChange={handleChange}
                      />
                      {error.start_date ? (
                        <p style={{ color: "red" }}>{error.start_date}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* Start Time */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="start_time"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="time"
                        name="start_time"
                        className="form-control store_input_field"
                        id="start_time"
                        value={ADDEDITDATA?.start_time}
                        onChange={handleChange}
                      />
                      {error.start_time ? (
                        <p style={{ color: "red" }}>{error.start_time}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* End Date */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-16 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="end_date"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>To :
                      </label> 
                      <input
                        type="date"
                        name="end_date"
                        className="form-control store_input_field"
                        id="end_date"
                        value={ADDEDITDATA?.end_date}
                        onChange={handleChange}
                      />   
                      {error.end_date ? (
                        <p style={{ color: "red" }}>{error.end_date}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* End Time */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="time"
                        name="end_time"
                        className="form-control store_input_field"
                        id="end_time"
                        value={ADDEDITDATA?.end_time}
                        onChange={handleChange}
                      />
                      {error.end_time ? (
                        <p style={{ color: "red" }}>{error.end_time}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* Machine Ref */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="pos_number" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Machine Ref. :{" "}
                      </label>
                      <input
                        title="Machine Ref."
                        placeholder="Machine Ref"
                        type="text"
                        name="pos_number"
                        className="form-control store_input_field"
                        id="pos_number"
                        value={invoiceData?.pos_number}
                        onChange={invoiceDataChange}
                      />
                      {error.pos_number ? ( <p style={{ color: "red" }}>{error.pos_number}</p> ) : ( "" )}
                    </div>
                    {/* Invoice No. */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="invoice_no" className="all_section_for_label_main_class" >Invoice no. :</label>
                      <input
                        title="Invoice No."
                        placeholder="Invoice No."
                        type="text"
                        name="invoice_no"
                        className="form-control store_input_field"
                        id="invoice_no"
                        value={invoiceData?.invoice_no}
                        onChange={invoiceDataChange}
                      />
                      {error.invoice_no ? ( <p style={{ color: "red" }}>{error.invoice_no}</p> ) : ( "" )}
                    </div>
                    {/* Invoice Date */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="invoice_date" className="all_section_for_label_main_class" ><span style={{ color: "red" }}>*</span>Invoice date :</label>
                      <input
                        title="Invoice Date"
                        placeholder="Invoice Date"
                        type="date"
                        name="invoice_date"
                        className="form-control store_input_field"
                        id="invoice_date"
                        value={invoiceData?.invoice_date || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.invoice_date ? ( <p style={{ color: "red" }}>{error.invoice_date}</p> ) : ( "" )}
                    </div>
                    {/* payment_mode */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="payment_mode" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Mode/Terms of payment :{" "}
                      </label>
                      <select name="payment_mode" id="payment_mode" className="form-control store_input_field" onChange={invoiceDataChange} >
                        <option value='' selected disabled >Choose your options</option>
                        <option value='Cash' >Cash</option>
                        <option value='Online' >Online</option>
                      </select>
                      {error.payment_mode ? ( <p style={{ color: "red" }}>{error.payment_mode}</p> ) : ( "" )}
                    </div>

                    {/* Lotto Total Sales */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="lottoTotalSales" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Daily Draw Total Sale :{" "}
                      </label>
                      <input
                        title="Daily Draw Total Sale"
                        placeholder="Daily Draw Total Sale"
                        type="number"
                        name="lottoTotalSales"
                        className="form-control store_input_field"
                        id="lottoTotalSales"
                        value={invoiceData?.lottoTotalSales || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.lottoTotalSales ? ( <p style={{ color: "red" }}>{error.lottoTotalSales}</p> ) : ( "" )}
                    </div>

                    {/* Lotto Total Commission */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="lottoTotalCommission" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Daily Draw Commission :{" "}
                      </label>
                      <input
                        title="Daily Draw Total Commission"
                        placeholder="Daily Draw Total Commission"
                        type="number"
                        name="lottoTotalCommission"
                        className="form-control store_input_field"
                        id="lottoTotalCommission"
                        value={invoiceData?.lottoTotalCommission || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.lottoTotalCommission ? ( <p style={{ color: "red" }}>{error.lottoTotalCommission}</p> ) : ( "" )}
                    </div>

                    {/* Lotto Amount Paid */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="lottoPaidAmount" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Daily Draw Amount Paid :{" "}
                      </label>
                      <input
                        title="Daily Draw Amount Paid"
                        placeholder="Daily Draw Amount Paid"
                        type="number"
                        name="lottoPaidAmount"
                        className="form-control store_input_field"
                        id="lottoPaidAmount"
                        value={invoiceData?.lottoPaidAmount || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.lottoPaidAmount ? ( <p style={{ color: "red" }}>{error.lottoPaidAmount}</p> ) : ( "" )}
                    </div>

                    {/* Lotto Total Sales */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="lottoIncentives" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Daily Draw Other Incentives :{" "}
                      </label>
                      <input
                        title="Daily Draw Other Incentives"
                        placeholder="Daily Draw Other Incentives"
                        type="number"
                        name="lottoIncentives"
                        className="form-control store_input_field"
                        id="lottoIncentives"
                        value={invoiceData?.lottoIncentives || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.lottoIncentives ? ( <p style={{ color: "red" }}>{error.lottoIncentives}</p> ) : ( "" )}
                    </div>

                    {/* Vouchers Total Sales */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="voucherTotalSales" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Voucher Total Sales :{" "}
                      </label>
                      <input
                        title="Voucher Total Sale"
                        placeholder="Voucher Total Sale"
                        type="number"
                        name="voucherTotalSales"
                        className="form-control store_input_field"
                        id="voucherTotalSales"
                        value={invoiceData?.voucherTotalSales || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.voucherTotalSales ? ( <p style={{ color: "red" }}>{error.voucherTotalSales}</p> ) : ( "" )}
                    </div>

                    {/* Vouchers Total Commission */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="voucherTotalCommission" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Voucher Total Commission :{" "}
                      </label>
                      <input
                        title="Voucher Total Commission"
                        placeholder="Voucher Total Commission"
                        type="number"
                        name="voucherTotalCommission"
                        className="form-control store_input_field"
                        id="voucherTotalCommission"
                        value={invoiceData?.voucherTotalCommission || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.voucherTotalCommission ? ( <p style={{ color: "red" }}>{error.voucherTotalCommission}</p> ) : ( "" )}
                    </div>

                    {/* Vouchers Amount Paid */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="voucherPaidAmount" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Voucher Amount Paid :{" "}
                      </label>
                      <input
                        title="Voucher Amount Paid"
                        placeholder="Voucher Amount Paid"
                        type="number"
                        name="voucherPaidAmount"
                        className="form-control store_input_field"
                        id="voucherPaidAmount"
                        value={invoiceData?.voucherPaidAmount || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.voucherPaidAmount ? ( <p style={{ color: "red" }}>{error.voucherPaidAmount}</p> ) : ( "" )}
                    </div>

                    {/* Vouchers Other Incentives */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="voucherIncentives" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Voucher Other Incentives :{" "}
                      </label>
                      <input
                        title="Voucher Other Incentives"
                        placeholder="Voucher Other Incentives"
                        type="number"
                        name="voucherIncentives"
                        className="form-control store_input_field"
                        id="voucherIncentives"
                        value={invoiceData?.voucherIncentives || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.voucherIncentives ? ( <p style={{ color: "red" }}>{error.voucherIncentives}</p> ) : ( "" )}
                    </div>

                    {/* e_comm Total Sales */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="e_commTotalSales" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>E-Comm. Total Sales :{" "}
                      </label>
                      <input
                        title="E-Comm. Total Sales"
                        placeholder="E-Comm. Total Sales"
                        type="number"
                        name="e_commTotalSales"
                        className="form-control store_input_field"
                        id="e_commTotalSales"
                        value={invoiceData?.e_commTotalSales || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.e_commTotalSales ? ( <p style={{ color: "red" }}>{error.e_commTotalSales}</p> ) : ( "" )}
                    </div>

                    {/* Points Total Commission */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="e_commTotalCommission" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>E-Comm. Total Commission :{" "}
                      </label>
                      <input
                        title="E-Comm. Total Commission"
                        placeholder="E-comm. Total Commission"
                        type="number"
                        name="e_commTotalCommission"
                        className="form-control store_input_field"
                        id="e_commTotalCommission"
                        value={invoiceData?.e_commTotalCommission || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.e_commTotalCommission ? ( <p style={{ color: "red" }}>{error.e_commTotalCommission}</p> ) : ( "" )}
                    </div>

                    {/* Points Amount Paid */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="e_commPaidAmount" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>E-Comm Amount Paid :{" "}
                      </label>
                      <input
                        title="E-Comm. Amount Paid"
                        placeholder="E-Comm. Amount Paid"
                        type="number"
                        name="e_commPaidAmount"
                        className="form-control store_input_field"
                        id="e_commPaidAmount"
                        value={invoiceData?.e_commPaidAmount || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.e_commPaidAmount ? ( <p style={{ color: "red" }}>{error.e_commPaidAmount}</p> ) : ( "" )}
                    </div>

                    {/* Points Other Incentives */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="e_commIncentives" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>E-Comm. Other Incentives :{" "}
                      </label>
                      <input
                        title="E-Comm. Other Incentives"
                        placeholder="E-Comm. Other Incentives"
                        type="number"
                        name="e_commIncentives"
                        className="form-control store_input_field"
                        id="e_commIncentives"
                        value={invoiceData?.e_commIncentives || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.e_commIncentives ? ( <p style={{ color: "red" }}>{error.e_commIncentives}</p> ) : ( "" )}
                    </div>

                    <hr className="mb-0"/>

                    {/* Total Sales */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data ">
                      <label htmlFor="totalSales" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Total sale :{" "}
                      </label>
                      <input
                        title="Total Sale"
                        placeholder="Total sale"
                        type="number"
                        name="totalSales"
                        className="form-control store_input_field"
                        id="totalSales"
                        disabled
                        value={invoiceData?.totalSales || ''}
                        // onChange={invoiceDataChange}
                      />
                      {error.totalSales ? ( <p style={{ color: "red" }}>{error.totalSales}</p> ) : ( "" )}
                    </div>
                    {/* Total Commission */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="totalCommission" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Total commission :{" "}
                      </label>
                      <input
                        title="Total Commission"
                        placeholder="Total commission"
                        type="number"
                        name="totalCommission"
                        className="form-control store_input_field"
                        id="totalCommission"
                        disabled
                        value={invoiceData?.totalCommission || ''}
                        // onChange={invoiceDataChange}
                      />
                      {error.totalCommission ? ( <p style={{ color: "red" }}>{error.totalCommission}</p> ) : ( "" )}
                    </div>
                    {/* Amount Paid */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="paidAmount" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Amount paid:{" "}
                      </label>
                      <input
                        title="Amount Paid"
                        placeholder="Amount paid"
                        type="number"
                        name="paidAmount"
                        className="form-control store_input_field"
                        id="paidAmount"
                        disabled
                        value={invoiceData?.paidAmount || ''}
                        // onChange={invoiceDataChange}
                      />
                      {error.paidAmount ? ( <p style={{ color: "red" }}>{error.paidAmount}</p> ) : ( "" )}
                    </div>
                    {/* Other Incentives */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="incentives" className="all_section_for_label_main_class" > Other incentives :{" "} </label>
                      <input
                        title="Total incentives"
                        placeholder="Total incentives"
                        type="number"
                        name="incentives"
                        className="form-control store_input_field"
                        id="incentives"
                        disabled
                        value={invoiceData?.incentives || ''}
                        // onChange={invoiceDataChange}
                      />
                      {error.incentives ? ( <p style={{ color: "red" }}>{error.incentives}</p> ) : ( "" )}
                    </div>
               
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                      <h4 style={{textAlign : "left"}} className="amount_heading">Due amount : KD {invoiceData?.totalDue?.toFixed(2) || 0}</h4>
                    </div>
                    <hr className="mb-0"/>

                    {/* Old Balance */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="old_balance" className="all_section_for_label_main_class amount_heading" > Old balance pending :{" "}</label>
                      <input
                        title="Old balance pending"
                        placeholder="Old balance pending"
                        type="number"
                        name="old_balance"
                        className="form-control store_input_field"
                        id="old_balance"
                        value={invoiceData?.old_balance ?? ''}
                        onChange={invoiceDataChange}
                      />
                      {error.old_balance ? ( <p style={{ color: "red" }}>{error.old_balance}</p> ) : ( "" )}
                    </div>
                    {/* Other Charges */}
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="other_charges" className="all_section_for_label_main_class amount_heading" > Other charges (if any) :{" "} </label>
                      <input
                        title="Other charges"
                        placeholder="Other charges"
                        type="number"
                        name="other_charges"
                        className="form-control store_input_field"
                        id="other_charges"
                        value={invoiceData?.other_charges || ''}
                        onChange={invoiceDataChange}
                      />
                      {error.other_charges ? ( <p style={{ color: "red" }}>{error.other_charges}</p> ) : ( "" )}
                    </div>

                  
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="add_in_due" className="all_section_for_label_main_class amount_heading" > Add in due :{" "}</label>
                      <select
                        name="add_in_due"
                        id="add_in_due"
                        className="form-control store_input_field"
                        value={addInDue}
                        onChange={(e) => setAddInDue(e.target.value)}
                      >
                        <option value="N">No</option>
                        <option value="Y">Yes</option>
                      </select>
                    </div>

                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-4 mb-2">
                      <h4 style={{textAlign : "left"}}>Total due as per statement : KD {getStatementDueAmount(invoiceData).toFixed(2) || 0}</h4>
                    </div>
                    <hr/>

                  </div>

                </div>

                <div className="inventory_edit_submit_btn mt-3">
                  <button type="button" className="btn btn-danger inventory_save_button mx-2" onClick={handlePreview} > Preview </button>
                  <button type="button" className="btn btn-primary inventory_save_button" onClick={handleGenerate} > Generate </button>
                </div>
              {/* </form> */}
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} text={loadingText} />
    </div>
  );
};

export default UserListEditPage;
